var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chartist',{staticStyle:{"height":"250px","overflow":"hidden"},attrs:{"data":_vm.data,"event-handlers":_vm.eventHandlers,"options":_vm.options,"ratio":_vm.ratio,"responsive-options":_vm.responsiveOptions,"type":_vm.type,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }